<div class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="page-container dashboard-container" [class]="dashboardHoverClass" [class.activity-expanded]="isRecentActivityExpanded" (click)="onDashboardClick($event)">
      <!-- Centered Header -->
      <div class="dashboard-header-section" [class.hidden]="expandedButton !== null">
    <div class="dashboard-title-wrapper">
      <h1 class="dashboard-title">
        What would you like to do today?
      </h1>
    </div>
  </div>
  
  <!-- Action Buttons -->
  <div class="dashboard-actions" [class.activity-open]="isRecentActivityExpanded">
    <div class="action-button-container">
      <!-- Title for expanded Profile Data -->
      <div class="expanded-title" *ngIf="expandedButton === 'profile-data'">
        <mat-icon [svgIcon]="getPageIcon()!" class="title-icon"></mat-icon>
        <h1>{{ getPageTitle() }}</h1>
      </div>
      
      <!-- Wrapper for side-by-side layout of button + toggle + info panel -->
      <div class="expanded-row" *ngIf="expandedButton === 'profile-data'">
        <div class="action-button dashboard-action-btn" 
             [class.expanded]="expandedButton === 'profile-data'"
             [class.info-open]="isInfoPanelExpanded"
             [class.collapsed]="expandedButton !== null && expandedButton !== 'profile-data'"
             (click)="onProfileDataClick(false)"
             (mouseenter)="expandedButton === null ? onProfileDataHover() : null"
             (mouseleave)="expandedButton === null ? onButtonLeave() : null">
          <div class="button-icon-wrapper" *ngIf="expandedButton !== 'profile-data'" (click)="onProfileDataClick(true); $event.stopPropagation()">
            <mat-icon svgIcon="chart-blue"></mat-icon>
          </div>
          <span class="button-text" *ngIf="expandedButton !== 'profile-data' && expandedButton === null">Data Assessment</span>
        
        <!-- Expanded content for Profile Data -->
        <div class="expanded-content profile-data-content" *ngIf="expandedButton === 'profile-data'">
          <div class="description-section" [class.transitioning]="isTextTransitioning">
            <p class="expanded-description-text">{{ getExpandedDescription('profile-data') }}</p>
          </div>
          
          <hr class="section-divider">
          
          <div class="data-select-section">
            <h3 class="get-started-title">Get Started</h3>
            
            <div class="upload-section">
                  <div class="add-button-section"
                    [class.has-profile-datasources]="selectedProfileDataSources.length > 0"
                    *ngIf="!uploadedFile && !uploadingProfile && !isLoadingProfileDataSource">
                 <div class="profile-datasource-list"
                   *ngIf="selectedProfileDataSources.length > 0">
                  <div *ngFor="let dataSource of selectedProfileDataSources" class="profile-datasource-item">
                    <mat-icon [svgIcon]="getDataSourceIcon(dataSource)"></mat-icon>
                    <span>{{ dataSource.dataSourceName }}</span>
                    <button mat-icon-button type="button"
                            [attr.aria-label]="'Remove ' + dataSource.dataSourceName"
                            (click)="removeProfileDataSource(dataSource); $event.stopPropagation()">
                      <mat-icon svgIcon="close"></mat-icon>
                    </button>
                  </div>
                </div>

                <app-data-source-picker
                  [allowUploadFile]="true"
                  [dataSources]="filteredDataSources"
                  [selectedDataSourceIds]="selectedProfileDataSourceIds"
                  [allowMultipleSelection]="true"
                  [isLoadingDataSources]="isLoadingDataSources"
                  (uploadFile)="onUploadFileClick('profile')"
                  (selectExisting)="onSelectExistingClick('profile')"
                  (createNew)="onCreateNewDatasourceClick('profile')"
                  (dataSourceSelected)="onDataSourceSelect($event, 'profile')">
                </app-data-source-picker>
                
                <p class="instruction-text" *ngIf="selectedProfileDataSources.length === 0">
                  Select data to start profiling
                </p>
              </div>
              
              <!-- Loading Spinner for Profile Data Upload -->
              <div class="upload-spinner" *ngIf="uploadingProfile && !uploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <!-- Loading Spinner for Profile Data Source Selection -->
              <div class="upload-spinner" *ngIf="isLoadingProfileDataSource && !uploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div *ngIf="uploadedFile" class="file-info">
                <mat-icon svgIcon="description"></mat-icon>
                <span>{{ uploadedFile!.name }}</span>
                <button mat-icon-button 
                        class="remove-file-btn"
                        (click)="onFileRemove(); $event.stopPropagation()">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
            
            <hr class="section-divider">
            
            <button class="go-btn"
                    [disabled]="!isProfileDataValid() || isCreating"
                    (click)="onProfileDataGo(); $event.stopPropagation()">
              <img [src]="isProfileDataValid() ? 'assets/icons/Arrow - Right Square-blue.svg' : 'assets/icons/Arrow - Right Square-grey.svg'" alt="Go" class="go-icon">
            </button>
          </div>
        </div>
        </div>
        
        <!-- Info Panel for Profile Data (slides from the right) -->
        <div class="info-panel" [class.visible]="isInfoPanelExpanded">
          <button class="close-info-btn" 
                  *ngIf="isInfoPanelExpanded"
                  (click)="toggleInfoPanel(); $event.stopPropagation()"
                  [title]="'Close info'">
            <mat-icon svgIcon="close-grey"></mat-icon>
          </button>
          <div class="info-panel-content">
            <div class="info-sections-wrapper">
              <div class="info-section">
              <h3 class="info-section-title">Best Use Cases</h3>
              <ul class="info-list">
                <li>Understanding new datasets before analysis</li>
                <li>Identifying data quality issues and missing values</li>
                <li>Documenting data structure for compliance or stakeholders</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Expected Outcomes</h3>
              <ul class="info-list">
                <li>Detailed statistical summary of all columns</li>
                <li>Visual distributions and pattern detection</li>
                <li>Data quality score and option to generate cleaning workflow</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Key Benefits</h3>
              <ul class="info-list">
                <li>Save hours of manual data exploration</li>
                <li>Catch data issues before they impact analysis</li>
                <li>Generate shareable quality reports</li>
              </ul>
            </div>
            </div>
            
            <a class="help-link" 
               (click)="openHelpWithFeature('profile-data', $event)"
               style="cursor: pointer;">
              Learn more about Data Assessment
            </a>
          </div>
        </div>
        
        <!-- Floating Info Toggle Button -->
        <button class="floating-info-toggle" 
                (click)="toggleInfoPanel(); $event.stopPropagation()"
                [class.open]="isInfoPanelExpanded"
                [title]="isInfoPanelExpanded ? 'Hide info' : 'See more information'">
          <img src="assets/icons/info-circle.svg" alt="Info" class="info-icon">
        </button>
      </div>
      
      <!-- Non-expanded button -->
      <div class="action-button dashboard-action-btn" 
           *ngIf="expandedButton !== 'profile-data'"
           [class.collapsed]="expandedButton !== null"
           (click)="onProfileDataClick(false)"
           (mouseenter)="expandedButton === null ? onProfileDataHover() : null"
           (mouseleave)="expandedButton === null ? onButtonLeave() : null">
        <div class="button-icon-wrapper" (click)="onProfileDataClick(true); $event.stopPropagation()">
          <mat-icon svgIcon="chart-blue"></mat-icon>
        </div>
        <span class="button-text" *ngIf="expandedButton === null">Data Assessment</span>
      </div>
      
      <div class="button-description profile-data-description" 
           [class.visible]="shouldShowDescription('profile-data')">
        <span>{{ getHoverDescription('profile-data') }}</span>
      </div>
    </div>
    
    <div class="action-button-container">
      <!-- Title for expanded Anomaly Detection -->
      <div class="expanded-title" *ngIf="expandedButton === 'anomaly-detection'">
        <mat-icon [svgIcon]="getPageIcon()!" class="title-icon"></mat-icon>
        <h1>{{ getPageTitle() }}</h1>
      </div>
      
      <!-- Wrapper for side-by-side layout of button + toggle + info panel -->
      <div class="expanded-row" *ngIf="expandedButton === 'anomaly-detection'">
        <div class="action-button dashboard-action-btn expanded" 
             [class.info-open]="isInfoPanelExpanded"
             (click)="onAnomalyDetectionClick(false)">
          <!-- Expanded content for Anomaly Detection -->
          <div class="expanded-content anomaly-detection-content">
          <div class="description-section" [class.transitioning]="isTextTransitioning">
            <p class="expanded-description-text">{{ getExpandedDescription('anomaly-detection') }}</p>
          </div>
          
          <hr class="section-divider">
          
          <div class="data-select-section">
            <h3 class="get-started-title">Get Started</h3>
            
            <div class="upload-section">
              <div class="add-button-section" *ngIf="!anomalyDetectionUploadedFile && !uploadingAnomaly && !isLoadingAnomalyDataSource">
                <app-data-source-picker
                  [allowUploadFile]="true"
                  [dataSources]="filteredDataSources"
                  [selectedDataSourceId]="selectedAnomalyDataSource?.dataSourceId"
                  [isLoadingDataSources]="isLoadingDataSources"
                  [checkIcon]="'check_circle_blue'"
                  (uploadFile)="onUploadFileClick('anomaly')"
                  (selectExisting)="onSelectExistingClick('anomaly')"
                  (createNew)="onCreateNewDatasourceClick('anomaly')"
                  (dataSourceSelected)="onDataSourceSelect($event, 'anomaly')">
                </app-data-source-picker>
                
                <p class="instruction-text">Select data to start anomaly detection</p>
              </div>
              
              <!-- Loading Spinner for Anomaly Detection Upload -->
              <div class="upload-spinner" *ngIf="uploadingAnomaly && !anomalyDetectionUploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div class="upload-spinner" *ngIf="isLoadingAnomalyDataSource && !anomalyDetectionUploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div *ngIf="anomalyDetectionUploadedFile" class="file-info">
                <mat-icon svgIcon="description"></mat-icon>
                <span>{{ anomalyDetectionUploadedFile!.name }}</span>
                <button mat-icon-button 
                        class="remove-file-btn"
                        (click)="onAnomalyFileRemove(); $event.stopPropagation()">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
            
            <hr class="section-divider">
            
            <button class="go-btn"
                    [disabled]="!isAnomalyDetectionValid() || isCreating"
                    (click)="onAnomalyDetectionGo(); $event.stopPropagation()">
              <img [src]="isAnomalyDetectionValid() ? 'assets/icons/Arrow - Right Square-blue.svg' : 'assets/icons/Arrow - Right Square-grey.svg'" alt="Go" class="go-icon">
            </button>
          </div>
        </div>
        </div>
        
        <!-- Info Panel for Anomaly Detection (slides from the right) -->
        <div class="info-panel" [class.visible]="isInfoPanelExpanded">
          <button class="close-info-btn" 
                  *ngIf="isInfoPanelExpanded"
                  (click)="toggleInfoPanel(); $event.stopPropagation()"
                  [title]="'Close info'">
            <mat-icon svgIcon="close-grey"></mat-icon>
          </button>
          <div class="info-panel-content">
            <div class="info-sections-wrapper">
              <div class="info-section">
              <h3 class="info-section-title">Best Use Cases</h3>
              <ul class="info-list">
                <li>Fraud detection in transaction data</li>
                <li>Quality monitoring in manufacturing or operations</li>
                <li>Identifying unusual trends in time-series data</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Expected Outcomes</h3>
              <ul class="info-list">
                <li>Flagged anomalous records with severity scores</li>
                <li>Visual highlighting of unusual patterns</li>
                <li>Detailed analysis of why items are flagged</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Key Benefits</h3>
              <ul class="info-list">
                <li>Catch critical issues before they cause problems</li>
                <li>Automate ongoing data monitoring</li>
                <li>Reduce false positives with intelligent scoring</li>
              </ul>
            </div>
            </div>
            
            <a class="help-link" 
               (click)="openHelpWithFeature('anomaly-detection', $event)"
               style="cursor: pointer;">
              Learn more about Anomaly Detection
            </a>
          </div>
        </div>
        
        <!-- Floating Info Toggle Button -->
        <button class="floating-info-toggle" 
                (click)="toggleInfoPanel(); $event.stopPropagation()"
                [class.open]="isInfoPanelExpanded"
                [title]="isInfoPanelExpanded ? 'Hide info' : 'See more information'">
          <img src="assets/icons/info-circle.svg" alt="Info" class="info-icon">
        </button>
      </div>
      
      <!-- Non-expanded button -->
      <div class="action-button dashboard-action-btn" 
           *ngIf="expandedButton !== 'anomaly-detection'"
           [class.collapsed]="expandedButton !== null"
           (click)="onAnomalyDetectionClick(false)"
           (mouseenter)="expandedButton === null ? onAnomalyDetectionHover() : null"
           (mouseleave)="expandedButton === null ? onButtonLeave() : null">
        <div class="button-icon-wrapper" (click)="onAnomalyDetectionClick(true); $event.stopPropagation()">
          <mat-icon svgIcon="radar-ai-blue"></mat-icon>
        </div>
        <span class="button-text" *ngIf="expandedButton === null">Detect Anomalies</span>
      </div>
      
      <div class="button-description anomaly-detection-description" 
           [class.visible]="shouldShowDescription('anomaly-detection')">
        <span>{{ getHoverDescription('anomaly-detection') }}</span>
      </div>
    </div>

    <div class="action-button-container">
      <div class="expanded-title" *ngIf="expandedButton === 'ai-readiness'">
        <mat-icon [svgIcon]="getPageIcon()!" class="title-icon"></mat-icon>
        <h1>{{ getPageTitle() }}</h1>
      </div>

      <div class="expanded-row" *ngIf="expandedButton === 'ai-readiness'">
        <div class="action-button dashboard-action-btn expanded"
             [class.info-open]="isInfoPanelExpanded"
             (click)="onAiReadinessClick(false)">
          <div class="expanded-content ai-readiness-content">
            <div class="description-section" [class.transitioning]="isTextTransitioning">
              <p class="expanded-description-text">{{ getExpandedDescription('ai-readiness') }}</p>
            </div>

            <hr class="section-divider">

            <div class="data-select-section">
              <h3 class="get-started-title">Get Started</h3>
              <div class="upload-section">
                <div class="add-button-section" *ngIf="!isLoadingDataSources">
                  <div class="profile-datasource-list" *ngIf="selectedAiReadinessDataSources.length > 0">
                    <div *ngFor="let dataSource of selectedAiReadinessDataSources" class="profile-datasource-item">
                      <mat-icon [svgIcon]="getDataSourceIcon(dataSource)"></mat-icon>
                      <span>{{ dataSource.dataSourceName }}</span>
                      <button mat-icon-button type="button"
                              [attr.aria-label]="'Remove ' + dataSource.dataSourceName"
                              (click)="removeAiReadinessDataSource(dataSource); $event.stopPropagation()">
                        <mat-icon svgIcon="close"></mat-icon>
                      </button>
                    </div>
                  </div>

                  <app-data-source-picker
                    [allowUploadFile]="false"
                    [dataSources]="filteredDataSources"
                    [selectedDataSourceIds]="selectedAiReadinessDataSourceIds"
                    [allowMultipleSelection]="true"
                    [isLoadingDataSources]="isLoadingDataSources"
                    (selectExisting)="onSelectExistingClick('ai')"
                    (createNew)="onCreateNewDatasourceClick('ai')"
                    (dataSourceSelected)="onDataSourceSelect($event, 'ai')">
                  </app-data-source-picker>
                  <p class="instruction-text" *ngIf="selectedAiReadinessDataSources.length === 0">
                    Select one or more data sources to assess AI readiness
                  </p>
                </div>

                <div class="upload-spinner" *ngIf="isLoadingDataSources">
                  <mat-spinner diameter="40"></mat-spinner>
                </div>
              </div>

              <hr class="section-divider">

              <button class="go-btn"
                      [disabled]="!isAiReadinessValid()"
                      (click)="onAiReadinessGo(); $event.stopPropagation()">
                <img [src]="isAiReadinessValid() ? 'assets/icons/Arrow - Right Square-blue.svg' : 'assets/icons/Arrow - Right Square-grey.svg'" alt="Go" class="go-icon">
              </button>
            </div>
          </div>
        </div>

        <div class="info-panel" [class.visible]="isInfoPanelExpanded">
          <button class="close-info-btn" *ngIf="isInfoPanelExpanded"
                  (click)="toggleInfoPanel(); $event.stopPropagation()" title="Close info">
            <mat-icon svgIcon="close-grey"></mat-icon>
          </button>
          <div class="info-panel-content">
            <div class="info-sections-wrapper">
              <div class="info-section">
                <h3 class="info-section-title">Best Use Cases</h3>
                <ul class="info-list">
                  <li>Assessing datasets before building AI or machine learning models</li>
                  <li>Comparing the readiness of multiple candidate datasets</li>
                  <li>Planning data improvement work before model development</li>
                </ul>
              </div>
              <div class="info-section">
                <h3 class="info-section-title">Expected Outcomes</h3>
                <ul class="info-list">
                  <li>Headline readiness scores across key data metrics</li>
                  <li>Evidence showing strengths, gaps, and potential risks</li>
                  <li>Practical next steps to improve model readiness</li>
                </ul>
              </div>
              <div class="info-section">
                <h3 class="info-section-title">Key Benefits</h3>
                <ul class="info-list">
                  <li>Make informed decisions about data suitability</li>
                  <li>Reduce avoidable modelling effort and rework</li>
                  <li>Build a clear, evidence-based data improvement plan</li>
                </ul>
              </div>
            </div>
            <a class="help-link" (click)="openHelpWithFeature('ai-readiness', $event)" style="cursor: pointer;">
              Learn more about AI Readiness
            </a>
          </div>
        </div>

        <button class="floating-info-toggle" (click)="toggleInfoPanel(); $event.stopPropagation()"
                [class.open]="isInfoPanelExpanded"
                [title]="isInfoPanelExpanded ? 'Hide info' : 'See more information'">
          <img src="assets/icons/info-circle.svg" alt="Info" class="info-icon">
        </button>
      </div>

      <div class="action-button dashboard-action-btn"
           *ngIf="expandedButton !== 'ai-readiness'"
           [class.collapsed]="expandedButton !== null"
           (click)="onAiReadinessClick(false)"
           (mouseenter)="expandedButton === null ? onAiReadinessHover() : null"
           (mouseleave)="expandedButton === null ? onButtonLeave() : null">
        <div class="button-icon-wrapper" (click)="onAiReadinessClick(true); $event.stopPropagation()">
          <mat-icon svgIcon="ai-brain-idea-blue"></mat-icon>
        </div>
        <span class="button-text" *ngIf="expandedButton === null">AI Readiness</span>
      </div>

      <div class="button-description ai-readiness-description"
           [class.visible]="shouldShowDescription('ai-readiness')">
        <span>{{ getHoverDescription('ai-readiness') }}</span>
      </div>
    </div>
    
    <div class="action-button-container">
      <!-- Title for expanded Clean Data -->
      <div class="expanded-title" *ngIf="expandedButton === 'clean-data'">
        <mat-icon [svgIcon]="getPageIcon()!" class="title-icon"></mat-icon>
        <h1>{{ getPageTitle() }}</h1>
      </div>
      
      <!-- Wrapper for side-by-side layout of button + toggle + info panel -->
      <div class="expanded-row" *ngIf="expandedButton === 'clean-data'">
        <div class="action-button dashboard-action-btn expanded" 
             [class.info-open]="isInfoPanelExpanded"
             (click)="onCleanDataClick(false)">
          <!-- Expanded content for Clean Data -->
          <div class="expanded-content">
          <div class="description-section" [class.transitioning]="isTextTransitioning">
            <p class="expanded-description-text">{{ getExpandedDescription('clean-data') }}</p>
          </div>
          
          <hr class="section-divider">
          
          <div class="data-select-section">
            <h3 class="get-started-title">Get Started</h3>
            
            <div class="upload-section">
              <div class="add-button-section" *ngIf="!cleanDataUploadedFile && !uploadingClean && !isLoadingCleanDataSource">
                <app-data-source-picker
                  [allowUploadFile]="false"
                  [dataSources]="filteredDataSources"
                  [selectedDataSourceId]="selectedCleanDataSource?.dataSourceId"
                  [isLoadingDataSources]="isLoadingDataSources"
                  [checkIcon]="'check_circle_blue'"
                  (selectExisting)="onSelectExistingClick('clean')"
                  (createNew)="onCreateNewDatasourceClick('clean')"
                  (dataSourceSelected)="onDataSourceSelect($event, 'clean')">
                </app-data-source-picker>
                
                <p class="instruction-text">Select data to start cleaning</p>
              </div>
              
              <!-- Loading Spinner for Clean Data Upload -->
              <div class="upload-spinner" *ngIf="uploadingClean && !cleanDataUploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div class="upload-spinner" *ngIf="isLoadingCleanDataSource && !cleanDataUploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div *ngIf="cleanDataUploadedFile" class="file-info">
                <mat-icon svgIcon="description"></mat-icon>
                <span>{{ cleanDataUploadedFile!.name }}</span>
                <button mat-icon-button 
                        class="remove-file-btn"
                        (click)="onCleanDataFileRemove(); $event.stopPropagation()">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
            
            <hr class="section-divider">
            
            <button class="go-btn"
                    [disabled]="!isCleanDataValid() || isCreating"
                    (click)="onCleanDataGo(); $event.stopPropagation()">
              <img [src]="isCleanDataValid() ? 'assets/icons/Arrow - Right Square-blue.svg' : 'assets/icons/Arrow - Right Square-grey.svg'" alt="Go" class="go-icon">
            </button>
          </div>
        </div>
        </div>
        
        <!-- Info Panel for Clean Data (slides from the right) -->
        <div class="info-panel" [class.visible]="isInfoPanelExpanded">
          <button class="close-info-btn" 
                  *ngIf="isInfoPanelExpanded"
                  (click)="toggleInfoPanel(); $event.stopPropagation()"
                  [title]="'Close info'">
            <mat-icon svgIcon="close-grey"></mat-icon>
          </button>
          <div class="info-panel-content">
            <div class="info-sections-wrapper">
              <div class="info-section">
              <h3 class="info-section-title">Best Use Cases</h3>
              <ul class="info-list">
                <li>Correcting inconsistent data formats</li>
                <li>Removing duplicates and handling missing values</li>
                <li>Standardising data for downstream analysis</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Expected Outcomes</h3>
              <ul class="info-list">
                <li>AI-powered data transformation workflows</li>
                <li>Automated cleaning and validation processes</li>
                <li>Clean, validated datasets ready for use</li>
              </ul>
            </div>
            
            <div class="info-section">
              <h3 class="info-section-title">Key Benefits</h3>
              <ul class="info-list">
                <li>Reduce manual data cleaning time by up to 80%</li>
                <li>Ensure consistency across your data workflow</li>
                <li>Track and audit all cleaning operations</li>
              </ul>
            </div>
            </div>
            
            <a class="help-link" 
               (click)="openHelpWithFeature('clean-data', $event)"
               style="cursor: pointer;">
              Learn more about Clean Data
            </a>
          </div>
        </div>
        
        <!-- Floating Info Toggle Button -->
        <button class="floating-info-toggle" 
                (click)="toggleInfoPanel(); $event.stopPropagation()"
                [class.open]="isInfoPanelExpanded"
                [title]="isInfoPanelExpanded ? 'Hide info' : 'See more information'">
          <img src="assets/icons/info-circle.svg" alt="Info" class="info-icon">
        </button>
      </div>
      
      <!-- Non-expanded button -->
      <div class="action-button dashboard-action-btn" 
           *ngIf="expandedButton !== 'clean-data'"
           [class.collapsed]="expandedButton !== null"
           (click)="onCleanDataClick(false)"
           (mouseenter)="expandedButton === null ? onCleanDataHover() : null"
           (mouseleave)="expandedButton === null ? onButtonLeave() : null">
        <div class="button-icon-wrapper" (click)="onCleanDataClick(true); $event.stopPropagation()">
          <mat-icon svgIcon="ai-scan-blue"></mat-icon>
        </div>
        <span class="button-text" *ngIf="expandedButton === null">Clean Your Data</span>
      </div>
      
      <div class="button-description clean-data-description" 
           [class.visible]="shouldShowDescription('clean-data')">
        <span>{{ getHoverDescription('clean-data') }}</span>
      </div>
    </div>
    
    <!-- HYPOTHESIS TESTING - COMMENTED OUT -->
    <!-- <div class="action-button-container">
      <div class="expanded-title" *ngIf="expandedButton === 'hypothesis-testing'">
        <mat-icon [svgIcon]="getPageIcon()!" class="title-icon"></mat-icon>
        <h1>{{ getPageTitle() }}</h1>
      </div>
      
      <div class="action-button dashboard-action-btn" 
           [class.expanded]="expandedButton === 'hypothesis-testing'"
           [class.collapsed]="expandedButton !== null && expandedButton !== 'hypothesis-testing'"
           (click)="onHypothesisTestingClick(false)"
           (mouseenter)="expandedButton === null ? onHypothesisTestingHover() : null"
           (mouseleave)="expandedButton === null ? onButtonLeave() : null">
        <div class="button-icon-wrapper" *ngIf="expandedButton !== 'hypothesis-testing'" (click)="onHypothesisTestingClick(true); $event.stopPropagation()">
          <mat-icon svgIcon="ai-brain-idea-blue"></mat-icon>
        </div>
        <span class="button-text" *ngIf="expandedButton !== 'hypothesis-testing' && expandedButton === null">Hypothesis Testing</span>
        
        <div class="expanded-content hypothesis-testing-content" *ngIf="expandedButton === 'hypothesis-testing'">
          <div class="content-column">
            <div class="profile-data-text">
              {{ hypothesisTestingInput || 'What data are you testing hypotheses on?' }}
            </div>
            
            <div class="upload-section flex align-center gap-16">
              <app-data-source-picker
                *ngIf="!hypothesisTestingUploadedFile && !uploadingHypothesis"
                [allowUploadFile]="true"
                [allowDataSourceSelection]="false"
                [showInfoIcon]="true"
                (uploadFile)="onUploadFileClick('hypothesis')">
              </app-data-source-picker>
              
              <div class="upload-spinner" *ngIf="uploadingHypothesis && !hypothesisTestingUploadedFile">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
              
              <div *ngIf="hypothesisTestingUploadedFile" class="file-info">
                <mat-icon svgIcon="description"></mat-icon>
                <span>{{ hypothesisTestingUploadedFile.name }}</span>
                <button mat-icon-button 
                        class="remove-file-btn"
                        (click)="onHypothesisTestingFileRemove(); $event.stopPropagation()">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
          </div>
          
          <button class="go-btn"
                  [disabled]="!isHypothesisTestingValid() || isCreating"
                  (click)="onHypothesisTestingGo(); $event.stopPropagation()">
            <img [src]="isHypothesisTestingValid() ? 'assets/icons/Arrow - Right Square-blue.svg' : 'assets/icons/Arrow - Right Square-grey.svg'" alt="Go" class="go-icon">
          </button>
        </div>
      </div>
      <div class="button-description hypothesis-testing-description" 
           [class.visible]="shouldShowDescription('hypothesis-testing')"
           [class.expanded]="expandedButton === 'hypothesis-testing'">
        <span *ngIf="expandedButton !== 'hypothesis-testing'">{{ getHoverDescription('hypothesis-testing') }}</span>
        <span *ngIf="expandedButton === 'hypothesis-testing'" class="expanded-description-text" [class.transitioning]="isTextTransitioning">{{ getExpandedDescription('hypothesis-testing') }}</span>
        <a *ngIf="expandedButton === 'hypothesis-testing'" 
           class="help-link" 
           (click)="openHelpWithFeature('hypothesis-testing', $event)"
           style="cursor: pointer;">
          Learn more about Hypothesis Testing
        </a>
      </div>
    </div> -->
  </div>
  
  <!-- Projects Section -->
  <div class="dashboard-projects-section">
    <div class="recent-activity-header" (click)="toggleRecentActivity()" [class.expanded]="isRecentActivityExpanded">
      <h2 class="projects-subheading" *ngIf="isRecentActivityExpanded">{{ activityHeaderText }}</h2>
      <div class="toggle-drawer-wrapper">
        <button class="toggle-drawer-btn" [class.expanded]="isRecentActivityExpanded">
          <mat-icon svgIcon="keyboard_arrow_up"></mat-icon>
        </button>
        <span class="view-recent-text">{{ isRecentActivityExpanded ? 'Hide' : 'View Recent' }}</span>
      </div>
      <div class="spacer" *ngIf="isRecentActivityExpanded"></div>
    </div>
    
    <div class="recent-activity-content" [class.expanded]="isRecentActivityExpanded">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading activity...</p>
    </div>
    
    <!-- Empty State -->
    <div *ngIf="!loading && filteredActivityItems.length === 0 && !error" class="empty-state">
      <mat-icon svgIcon="folder_open"></mat-icon>
      <p>No recent activity. Click an action button above to get started!</p>
    </div>
    
    <!-- Activity Cards -->
    <div *ngIf="!loading && !error && filteredActivityItems.length > 0" class="projects-cards">
      <div *ngFor="let item of filteredActivityItems.slice(0, 3)" class="project-card-wrapper">
        <div class="project-card" (click)="onActivityItemClick(item)">
          <div class="project-card-header">
            <mat-icon [svgIcon]="getActivityIcon(item)" class="project-icon"></mat-icon>
            <!-- <div class="project-status" [ngClass]="getActivityStatusClass(item)">
              {{ getActivityStatus(item) }}
            </div> -->
          </div>
          <h3 class="project-name">{{ item.name }}</h3>
        </div>
        <div class="project-card-meta">
          <span class="project-updated">Last Edited {{ item.lastActionAt | date:'yyyy-MM-dd HH:mm' }}</span>
        </div>
      </div>
      
      <!-- View All Projects Card -->
      <div class="project-card-wrapper view-all-wrapper">
        <div class="project-card view-all-card" (click)="onViewAllProjects()">
          <div class="view-all-content">
            <img src="assets/icons/Docs-grey.svg" alt="View All" class="view-all-icon">
            <span class="view-all-text">View All Activity</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
  
</div>

<!-- Creating Loading Overlay -->
<div class="creating-overlay" *ngIf="isCreating">
  <div class="creating-overlay-content">
    <mat-spinner diameter="48"></mat-spinner>
    <p class="creating-message">{{ creatingMessage }}</p>
  </div>
</div>

</div>
</div>
